/* eslint-disable react/no-danger */
import React from 'react'
import { CategoryTitle, Text } from 'components'
import styles from './AboutSection.module.scss'

const AboutSection = ({ description, sanitizer }) => {
  if (!description) return null

  return (
    <section className={styles.aboutSection}>
      <CategoryTitle icon="about" title="Sobre" />
      <Text fontSize="medium" color="lightTextColor">
        <span
          className={styles.strong}
          dangerouslySetInnerHTML={{
            __html: sanitizer(
              `<p>${description.replace(/(?:\r\n|\r|\n)/g, '<br />')}</p>`
            ),
          }}
        />
      </Text>
    </section>
  )
}

export default AboutSection
